module.exports = __webpack_public_path__ + "static/img/shooting02.39c45de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/photographing/shooting02.jpg
// module id = D/86
// module chunks = 0